import { postIam } from '../../apis';
import { IS_MOBILE } from '../../constants';
import {
  getIframe,
  getLocationPath,
  setAddEventListener,
  showBottomSheet,
} from '../../helpers';
import { setAlertModal, showAlertModal } from '../components/alert';

const ResetPassStep1 = {
  render: async () => {
    return `
    <div>
      <a id="connect_pay_back_button" class="c_back"></a>
    </div>
    <div class="c_title1 m_b_50">결제 비밀번호 재설정</div>

    <div>
      <form id="reqKMCISForm" method="post" action="#">
        <input type="hidden" id="tr_cert" name="tr_cert" />
        <input type="hidden" id="tr_url" name="tr_url" />
        <input type="hidden" id="tr_add" name="tr_add" />
      </form>
    </div>
`;
  },
  afterRender: async () => {
    setAlertModal();
    setAddEventListener('connect_pay_back_button', () => history.back());

    // 본인인증 연동
    try {
      // TODO: 비번찾기 본인인증 관련 분리 필요
      const data = await postIam('getKmcertInfo', { plusInfo: '' });
      const callbackUrl = `${getLocationPath()}#conpay_reset-pass-step2`;

      getIframe().getElementById('tr_cert').value = data.resultData.tr_cert;
      getIframe().getElementById('tr_url').value = callbackUrl;
      getIframe().getElementById('tr_add').value = 'N';
    } catch (e) {
      showBottomSheet('오류', e.resultMessage || e);
      console.error(e.resultMessage || e);
    }

    if (IS_MOBILE) {
      // 모바일일 경우
      getIframe().getElementById('reqKMCISForm').target = '';
      getIframe().getElementById('reqKMCISForm').action =
        process.env.KMCERT_URL;
      getIframe().getElementById('reqKMCISForm').submit();
    } else {
      // 모바일이 아닐 경우
      const target = 'KMCISWindow';
      const features =
        'width=425, height=550, resizable=0, scrollbars=no, status=0, titlebar=0, toolbar=0, left=435, top=250';
      const KMCIS_window = window.open('', target, features);

      const errMessgae =
        ' ※ 윈도우 XP SP2 또는 인터넷 익스플로러 7 사용자일 경우에는 \n    화면 상단에 있는 팝업 차단 알림줄을 클릭하여 팝업을 허용해 주시기 바랍니다. \n\n※ MSN,야후,구글 팝업 차단 툴바가 설치된 경우 팝업허용을 해주시기 바랍니다.';
      if (KMCIS_window == null) {
        showAlertModal('오류', errMessgae);
      } else {
        getIframe().getElementById('reqKMCISForm').target = 'KMCISWindow';
        getIframe().getElementById('reqKMCISForm').action =
          process.env.KMCERT_URL;
        getIframe().getElementById('reqKMCISForm').submit();
      }
    }
  },
};
export default ResetPassStep1;
